<template>
  <div class="contentGlobal">
    <div class="contLogin">
      <div class="login boxLogin relative">
        <button @click="$router.go(-1)" class="btnBack"><icon name="angle-left"></icon> {{ $t("messages.back") }}</button>
        <b-row v-if="detailUser">
          <b-col>
            <!-- User details -->
            <h4>{{ $t("messages.userDetails") }}</h4>
            <form @submit.prevent>
              <b-row>
                <!-- Email -->
                <b-col cols="2" class="right">
                  <label class="w100 right">{{ $t("messages.login.email") }}</label>
                </b-col>
                <b-col cols="10">
                  <b-form-input
                    type="text"
                    v-bind:placeholder="$t('messages.login.placeholder.email')"
                    v-model="detailUser.email"
                    readonly
                  ></b-form-input>
                </b-col>
              
              </b-row>
              <b-row class="mtop10">
                <!-- Name -->
                <b-col cols="2" class="right">
                  <label class="w100 right">{{ $t("messages.login.name") }}</label>
                </b-col>
                <b-col cols="10">
                  <b-form-input type="text" placeholder="Name" v-model.trim="detailUser.name"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mtop10">
                <!-- Phone -->
                <b-col cols="2" class="right">
                  <label class="w100 right">{{ $t("messages.login.phone") }}</label>
                </b-col>
                <b-col cols="10">
                  <b-form-input type="text" placeholder="phone" v-model.trim="detailUser.phone"></b-form-input>
                </b-col>
              </b-row>
               <b-row class="mtop10">
                <!-- country -->
                <b-col cols="2" class="right">
                  <label class="w100 right">{{ $t("messages.login.country") }}</label>
                </b-col>
                <b-col cols="10">
                  <b-form-select class="form-control"  v-model="detailUser.country" :options="countries"/>
                </b-col>
              </b-row>
              <b-row class="mtop10" v-if="userProfile.isSuperAdmin">
                <!-- Company -->
                <b-col cols="2" class="right">
                  <label class="w100 right">{{ $t("messages.company") }}</label>
                </b-col>
                <b-col cols="10">
                  <select class="form-control" :required="true" v-model="detailUser.company">
                    <option
                      v-for="option in companies"
                      :key="option.code"
                      v-bind:value="option.code"
                      :selected="option.code == detailUser.company"
                    >{{ option.name }}</option>
                  </select>
                </b-col>
              </b-row>
              <b-row class="mtop10" v-if="userProfile.isSuperAdmin">
                <!-- User type -->
                <b-col cols="2" class="right">
                  <label class="w100 right">{{ $t("messages.userType") }}</label>
                </b-col>
                <b-col cols="10">
                  <select class="form-control" :required="true" v-model="detailUser.role">
                    <option
                      v-for="option in roles"
                      :key="option.code"
                      v-bind:value="option.code"
                      :selected="option.code == detailUser.role"
                    >{{ option.name }}</option>
                  </select>
                </b-col>
              </b-row>
              <b-row class="mtop10">
                <!-- Language -->
                <b-col cols="2" class="right">
                  <label class="w100 right">{{ $t("messages.language") }}</label>
                </b-col>
                <b-col cols="10">
                  <select class="form-control" :required="true" v-model="detailUser.language">
                    <option
                      v-for="option in languages"
                      :key="option.code"
                      v-bind:value="option.code"
                      :selected="option.code == detailUser.language"
                    >{{ option.name }}</option>
                  </select>
                </b-col>
              </b-row>

              <b-row class="mtop10">
                <!-- Pools -->
                <b-col cols="2" class="right">
                  <label class="w100 right ptop15">{{ $t("messages.nav.pools") }}</label>
                </b-col>
                <b-col cols="10">
                  <div class="w100 chips">
                    <md-chip class="md-primary" style="margin:3px" v-for="(item, key) in pools" :key="key" md-deletable @click="onDeletePool(item)">
                      <small>{{ item.id }} {{ (item.name) ? '('+item.name+')' : '' }}</small>
                    </md-chip>
                    <span @click="$modal.show('new-pool');">
                      <icon name="plus"></icon>
                    </span>
                  </div>
                </b-col>
              </b-row>
              <!-- Update user -->
              <button @click="updateUser" class="button mtop20 save">
                {{ $t("messages.updateUser") }}
                <icon name="save"></icon>
              </button>
            </form>
            <!-- Change password -->
            <div v-if="userProfile.isSuperAdmin">
            <h4 class="mtop20">Password actions</h4>
            <form @submit.prevent="profile">
                <b-row class="form-group" :class="{ 'form-group--error': $v.changePass.password.$error }">
                    <b-col cols="2" class="right"><label class="form__label">{{ $t("messages.login.password") }}</label></b-col>
                    <b-col cols="10"><input class="form-control" type="password" v-model.trim="$v.changePass.password.$model"/></b-col>
                </b-row>
                <b-row  v-if="$v.changePass.$error">
                    <div class="error" v-if="!$v.changePass.password.isPasswordSafe">{{ $t('messages.login.error.notSafe', { field: $t("messages.login.password"), value: $v.changePass.password.$params.isPasswordSafe }) }} </div>
                </b-row>
    
                <b-row class="form-group" :class="{ 'form-group--error': $v.changePass.repeatPassword.$error }">
                    <b-col cols="2" class="right"><label class="form__label">{{ $t("messages.login.repeatPassword") }}</label></b-col>
                    <b-col cols="10" class="right"><input class="form-control" type="password" v-model.trim="$v.changePass.repeatPassword.$model" data-vv-validate-on="blur" /></b-col>
                </b-row>
                <b-row v-if="$v.changePass.$error">
                    <div class="error" v-if="!$v.changePass.repeatPassword.sameAsPassword"> {{ $t('messages.login.error.passwordIdentical') }}</div>
                </b-row>
                <button
                 @click="sendPasswordResetEmail"
                  class="button mauto"
              >{{ $t("messages.passwordResetEmail") }}</button>
                <button type="submit" class="success">
                    <!-- Update password -->
                    {{ $t("messages.updatePassword") }}
                </button>
            </form>
            <h4 class="mtop20">Delete account</h4>
            <el-row type="flex" class="mtop10">
              <b-alert class="w100" show variant="warning"><icon name="info-circle"> </icon><br/>
                This action can't be undone. The user data will be removed 
              </b-alert>
            </el-row>
            <button @click="confirmDelete" class="delete">
                DELETE USER ACCOUNT
            </button>
          
          </div>
         
          </b-col>
        </b-row>
        <b-row v-else class="content">
          <!-- The user does not exists -->
          {{ $t("messages.userNotExist") }}
        </b-row>
      </div>
    </div>
    <modal name="new-pool"
      transition="nice-modal-fade"
      :width="450"
      :height="200"
      :pivot-y="0.5"
      :adaptive="true"
      :scrollable="true"
      :reset="true"
      :clickToClose="false">
      <div class="box-modal">
        <div slot="top-right">
          <b-btn @click="$modal.hide('new-pool');" class="closePopup">
            <icon name="times-circle"></icon>
          </b-btn>
        </div>
        <b-row>
          <!-- Pool ID -->
          <b-col cols="3" class="right">
            <label class="w100 right">{{ $t("messages.nodeID") }}</label>
          </b-col>
          <b-col cols="9">
            <b-form-input type="text" v-model="newPoolId" placeholder="Enter Pool ID"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3" class="right"></b-col>
          <b-col cols="9">
            <label class="error">{{ message }}</label>
          </b-col>
        </b-row>
        <b-row class="ptop15 contBtn">
          <!-- Add pool -->
          <b-button
            @click="addPool()"
            class="button mauto"
            :disabled="newPoolId == null"
          >{{ $t("messages.addPool") }}</b-button>
        </b-row>
      </div>
    </modal>
    <b-modal id="unsubscribe" ref="unsubscribe">
        <b-container>
            <p> {{ $t("messages.poolUnsubscribe") }} : <strong>{{ (selectedPoolId) ? selectedPoolId.id : '' }} </strong>? </p>
        </b-container>
        <div slot="modal-footer" >
            <button class="float-right btn btnPerso delete" @click="onChipDelete()">
                {{ $t("messages.remove") }}
            </button>
        </div>
    </b-modal>
    <b-modal ref="delete-account" hide-footer centered title="Info">
      <div class="d-block text-center">
        <h5>Please, confirm the delete account for user: {{detailUser.email}}</h5>
      </div>
      <button class="float-right btn btnPerso " @click="onUserDelete(1)">
         Delete
        </button>
        <button class="float-right btn btnPerso " @click="onUserDelete(0)">
          Cancel
        </button>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required, email, sameAs, minLength, maxLength } from "vuelidate/lib/validators";

const reg = /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>[\]\/\\-]).{8,25}$/;
const isPasswordSafe = (value) =>  (reg.test(value))

export default {
  name: "user",
  data() {
    return {
      id: "",
      name: "",
      email: "",
      lang: "",
      newPoolId: null,
      selectedPoolId: null,
      message: "",
      detailUser: null,
      changePass: {
        password: "",
        repeatPassword: ""
      },
      fields: [
        { key: "id", label: "ID" },
        {
          key: "name",
          label: this.$i18n.t("messages.login.name"),
          t: "message.login.name"
        },
        {
          key: "insertAt",
          sortable: true,
          label: this.$i18n.t("messages.insertAt"),
          t: "message.insertAt"
        }
      ],
      pools: [],
    };
  },
  validations: {
    changePass: {
            password: {
                required,
                minLength: minLength(8),
                maxLength: maxLength(25),
                isPasswordSafe
            },
            repeatPassword: {
                sameAsPassword: sameAs('password')
            }
        },
    },
  watch: {
    "$i18n.locale": function(oldV, newV) {
      this.setCountries();
    }
  },
  mounted() {
    this.id = this.$route.params.userId;
    this.getUserById(this.$route.params.userId);
  },
  created(){
      this.setCountries()
  },
  computed: {
    countriesList: function () {
      var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
      return this.languages[index].countries;
     },
    ...mapState(["roles", "languages", "companies", "userProfile"])
  },

  methods: {
    profile() {
      this.$v.changePass.$touch();
        if (this.$v.changePass.$error){
          return
        }
        this.sendPasswordReset();
    },
    onDeletePool(id){
      this.selectedPoolId = id;
      this.$refs['unsubscribe'].show()
    },
    setCountries(){
      this.countries = this.countriesList
    },
    addPool() {
      let exists = this.detailUser.pools.findIndex(x => x.id === this.newPoolId);
      if (exists >= 0) {
        // Pool already assigned to user
        this.message = this.$t("messages.poolAlreadyAssigned");
        return true;
      }

      this.$store.dispatch("getPoolById", { id: this.newPoolId }).then(
        pool => {
          if (pool) {
            this.detailUser.pools.push(pool.id);
            //Add to chips 
            this.pools.push({id: pool.id, name: pool.form.name})
            this.$modal.hide("new-pool");
          } else {
            // The pool does not exists
            this.message = this.$t("messages.poolNotExist");
          }
        },
        error => {
          this.message = error;
        }
      );
    },

    onChipDelete() {
      if(this.selectedPoolId){
        var index = this.detailUser.pools.findIndex(x => x === this.selectedPoolId.id);
        if (index >= 0) {
          this.detailUser.pools.splice(index, 1);
          this.pools.splice(index, 1);
          this.selectedPoolId = null
          this.$refs['unsubscribe'].hide()
        }
      }

    },
    getUserById(id) {
      this.loading = true;
      this.$store.dispatch("getUserById", {id: this.id}).then(
          response => {
            if (response) {
              this.detailUser = response;
              this.isLoading = true;
              this.fillPools(this.detailUser.pools);
            } else {
              this.disableForm = true;
              // The user does not exists
              this.message = this.$t("messages.userNotExists");
            }
          },
          error => {
            this.detailPool = null;
            // Error retrieving data
            this.message = this.$t("messages.retrieveDataError");
          }
        );
    },
    fillPools(arr){
      arr.forEach(id => {
         this.$store.dispatch("getPoolById", { id: id}).then(
            pool => {
            if (pool) {
              this.pools.push({id: pool.id, name: pool.form.name})
            }
            })
      });
    },
    updateUser() {
      //   Updating user / Sending data
      this.$snotify.async(
        this.$t("messages.alertSendingData"),
        () =>
          new Promise((resolve, reject) => {
            this.$store
              .dispatch("updateUser", {
                id: this.id,
                fields: this.detailUser
              })
              .then(
                response => {
                  resolve({
                    //    User updated
                    body: this.$t("messages.userUpdated"),
                    config: {
                      timeout: 1000,
                      closeOnClick: true
                    }
                  });
                },
                error => {
                  reject({
                    // Error updating user
                    body: this.$t("messages.userUpdatingError"),
                    config: {
                      timeout: 3000,
                      closeOnClick: true
                    }
                  });
                }
              );
          })
      );
    },
    sendPasswordResetEmail() {
      // Send password reset email / Sending data
      this.$snotify.async(
        this.$t("messages.passwordResetEmail"),
        () =>
          new Promise((resolve, reject) => {
            this.$store
              .dispatch("sendPasswordResetEmail", {
                id: this.id,
                email: this.detailUser.email
              })
              .then(
                response => {
                  resolve({
                    //    User updated
                    body: this.$t("messages.userUpdated"),
                    config: {
                      timeout: 1000,
                      closeOnClick: true
                    }
                  });
                },
                error => {
                  reject({
                    // Error updating user
                    body: this.$t("messages.userUpdateError"),
                    config: {
                      timeout: 3000,
                      closeOnClick: true
                    }
                  });
                }
              );
          })
      );
    },
    sendPasswordReset() {
      this.$snotify.async(
        "Reset user password",
        () =>
          new Promise((resolve, reject) => {
            this.$store
              .dispatch("userAdmin", {
                operation: 'resetPassword',
                userId: this.id,
                pass: this.changePass.password
              })
              .then(
                response => {
                  resolve({
                    //    User updated
                    body: this.$t("messages.userUpdated"),
                    config: {
                      timeout: 1000,
                      closeOnClick: true
                    }
                  });
                },
                error => {
                  reject({
                    // Error updating user
                    body: this.$t("messages.userUpdateError"),
                    config: {
                      timeout: 3000,
                      closeOnClick: true
                    }
                  });
                }
              );
          })
      );
    },
    confirmDelete(){
      this.$refs['delete-account'].show()
    },
    onUserDelete(confirmed) {
      this.$refs['delete-account'].hide()
      if(confirmed){
        this.$snotify.async(
          "Delete user account",
          () =>
            new Promise((resolve, reject) => {
              this.$store
                .dispatch("userAdmin", {
                  operation: 'deleteAccount',
                  userId: this.id,
                  pass: null
                })
                .then(
                  response => {
                    resolve({
                      //    User updated
                      body: 'The user account has been deleted',
                      config: {
                        timeout: 1000,
                        closeOnClick: true
                      }
                    });
                  },
                  error => {
                    reject({
                      // Error updating user
                      body: 'The user account can not be deleted',
                      config: {
                        timeout: 3000,
                        closeOnClick: true
                      }
                    });
                  }
                );
            })
        );
      }
    }
  }
};
</script>

<style scoped>
.box-modal {
  background: white;
  overflow: hidden;
  width: 400px;
  height: 200px;
  border-radius: 5px;
  /* box-sizing: border-box;
  box-shadow: 0 0 40px black; */
  color: #8b8c8d;
}


.success {
  border-color: green;
  color:green
}

.success:hover {
  background-color:green;
  border-color: green;
}

.error {
  font-size: 12px;
  color: sienna;
}

/* .v--modal-overlay[data-modal="new-pool"] {
  background: rgba(134, 134, 134, 0.3);
} */

.chip.md-chip {
  background-color: #dddddd;
}
.md-switch {
  display: flex;
}
/* .boxLogin button {

} */
</style>



// WEBPACK FOOTER //
// src/components/User.vue